import { render } from "./LoginView.vue?vue&type=template&id=5e520d10&scoped=true&ts=true"
import script from "./LoginView.vue?vue&type=script&lang=ts"
export * from "./LoginView.vue?vue&type=script&lang=ts"

import "./LoginView.vue?vue&type=style&index=0&id=5e520d10&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5e520d10"]])

export default __exports__